<template>
  <CountdownProvider
    :date="dateAsTime"
    v-slot="{ days, hours, minutes, seconds }"
  >
    <div
      class="absolute inset-0 bg-black flex flex-col items-center justify-center text-white"
    >
      <div class="uppercase sm:text-lg opacity-40">
        Stream starting
      </div>

      <div class="flex py-3">
        <div class="lc-countdown-tick">
          {{ days }}
          <div class="lc-countdown-unit">days</div>
        </div>
        <div class="lc-countdown-separator">:</div>
        <div class="lc-countdown-tick">
          {{ hours }}
          <div class="lc-countdown-unit">hours</div>
        </div>
        <div class="lc-countdown-separator">:</div>
        <div class="lc-countdown-tick">
          {{ minutes }}
          <div class="lc-countdown-unit">minutes</div>
        </div>
        <div class="lc-countdown-separator">:</div>
        <div class="lc-countdown-tick">
          {{ seconds }}
          <div class="lc-countdown-unit">seconds</div>
        </div>
      </div>

      <div class="lc-countdown-timezones">
        <div>{{ newYorkTime }} (New York)</div>
        <span class="opacity-60">/</span>
        <div>{{ genevaTime }} (Geneva)</div>
        <span class="opacity-60">/</span>
        <div>{{ jerusalemTime }} (Jerusalem)</div>
      </div>
    </div>
  </CountdownProvider>
</template>

<script>
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import CountdownProvider from './../../components/countdown-provider';

dayjs.extend(utc);
dayjs.extend(timezone);

export default {
  components: { CountdownProvider },

  props: {
    date: String
  },

  computed: {
    dateAsTime() {
      return new Date(this.date).getTime();
    },

    newYorkTime() {
      return this.timeInTimezone('America/New_York');
    },

    genevaTime() {
      return this.timeInTimezone('Europe/Zurich');
    },

    jerusalemTime() {
      return this.timeInTimezone('Asia/Jerusalem');
    }
  },

  methods: {
    timeInTimezone(tz) {
      return dayjs(this.date)
        .tz(tz)
        .format('HH:mm');
    }
  }
};
</script>

<style>
.lc-countdown-tick,
.lc-countdown-separator {
  @apply text-white text-center;
  @apply opacity-70;
  font-size: 2.5rem;

  @screen sm {
    font-size: 4.5rem;
  }

  @screen md {
    font-size: 6.5rem;
  }

  @screen lg {
    font-size: 7.5rem;
  }
}

.lc-countdown-unit {
  @apply text-base uppercase;
  @apply opacity-50;
  @apply hidden;

  @screen sm {
    @apply block;
  }

  @screen md {
    @apply text-xl;
  }
}

.lc-countdown-timezones {
  @apply flex gap-1 text-white text-opacity-40;

  font-size: 0.875rem;

  @screen sm {
    font-size: 1rem;
  }

  @screen md {
    font-size: 1.25rem;
  }

  @screen lg {
    font-size: 1.5rem;
  }
}
</style>
